import * as React from 'react';

import { useContext } from 'react';
import { UIHeading3, UIText3 } from '@cian/ui-kit';
import { PhoneLinkWrapper } from '../../components/DynamicPhoneLinkWrapper';
import { PhoneLinkQRCode } from '../../components/PhoneLinkQRCode';
import { PhonesPreloader } from '../../components/PhonesPreloader';
import { TPlaceType } from '../../types/promoDetails/callButton';
import { PromoOfferCardContext } from '../../utils/promoOfferCardContext';
import { useCalltracking } from '../CallButton/useCalltracking';

interface INewbuildingDynamicPhoneProps {
  placeType: TPlaceType;
  onQRShowHandler(): void;
}

export const NewbuildingDynamicPhone = ({
  placeType,
  onQRShowHandler,
}: INewbuildingDynamicPhoneProps): React.JSX.Element => {
  const { builder } = useContext(PromoOfferCardContext);

  const showBuilderName = React.useMemo(() => placeType === 'promoOffer' && Boolean(builder), [placeType, builder]);

  const { linkPhone, dynamicPhone, responseEnded } = useCalltracking({
    placeType,
  });

  if (!responseEnded) {
    return <PhonesPreloader />;
  }

  return (
    <PhoneLinkWrapper
      phone={
        <UIHeading3>
          <a href={linkPhone}>{dynamicPhone}</a>
        </UIHeading3>
      }
      builder={showBuilderName && <UIText3 color="text-secondary-default">{builder?.name}</UIText3>}
      qr={<PhoneLinkQRCode phoneLink={linkPhone} onQRShow={onQRShowHandler} />}
    />
  );
};
